
export default {
  name: 'SelectWithOptionsSearchItem',
  props: {
    setModel: {
      type: Function,
      default() {
        return () => {}
      },
    },
    item: {
      type: Object,
      default() {
        return {}
      },
    },
    listLeftPadding: {
      type: String,
      default: '12px',
    },
    index: {
      type: Number || null,
      default: null,
    },
    activeId: {
      type: Number || null,
      default: null,
    },
    nameField: {
      type: String,
      default: 'name',
    },
  },
  computed: {
    title() {
      return this.item[this.nameField]
    },
  },
  methods: {
    select() {
      this.setModel(this.item.id)
    },
  },
}
